import getUserTier from './api/getUserTier';

export enum SubscriptionType {
  GOLD_OLD = 'gold_old',
  PRO = 'pro',
  MAX_STARTER = 'max_starter',
  MAX_PERFORMANCE = 'max_performance',
}

const PRO_SUBSCRIPTIONS: ReadonlySet<string> = new Set([
  SubscriptionType.GOLD_OLD,
  SubscriptionType.PRO,
  SubscriptionType.MAX_STARTER,
  SubscriptionType.MAX_PERFORMANCE,
]);

const isProUser = async (): Promise<boolean> => {
  const tier = await getUserTier();
  return tier ? PRO_SUBSCRIPTIONS.has(tier.id) : false;
};

export default isProUser;
